<app-menu-common url="sales"></app-menu-common>

<div class="pagecontent">
  <div class="pagetitle grey" >RSPs "Opérations Ponctuelles"</div>
  <div class="table-container">
    @if (rsps.length > 0) {
      <table>
        <thead>
          <tr>
            <!-- <th>ID</th> -->
            <th>Date Comptable</th>
            <th>Org. AMO</th>
            <th>Réf. Dette</th>
            <th>Nat. Opé.</th>
            <th>Nat. Dette</th>
            <th>Code</th>
            <th>Libellé</th>
            <th>Montant</th>
            <th>Période</th>
            <th>Période</th>
            <th>NIR</th>
            <th>Lib. Virement</th>
          </tr>
        </thead>
        <tbody>
          @for (rsp of rsps; track rsp) {
            <tr>
              <!-- <td>{{ rsp.id }}</td> -->
              <td>{{ rsp.dateComptable | date:'dd/MM/yyyy' }}</td>
              <td class="col-group-left">{{ rsp.typeEmetFic }} - {{ rsp.numEmetFic }}</td>
              <td>{{ rsp.data?.MFI?.refDette }}</td>
              <td>{{ stateHelper.natureOperationLabels[rsp.data?.MFI?.natureOperation] }}</td>
              <td>{{ stateHelper.natureDetteLabels[rsp.data?.MFI?.natureDette] }}</td>
              <td class="">{{ rsp.data.autrePaiement?.detailAutrePaiement.code }}</td>
              <td class="">{{ rsp.data.autrePaiement?.detailAutrePaiement.libelle }}</td>
              @if (rsp.data.autrePaiement) {
                <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.autrePaiement?.montantPaiement) | fcfse) || '' }}</td>
              }
              @if (!rsp.data.autrePaiement) {
                <td class="text-right font-mono bold">{{ ($safeNavigationMigration(rsp.data.MFI?.montantMFI) | fcfse) || '' }}</td>
              }
              <td>{{ rsp.data.autrePaiement?.detailAutrePaiement?.periode }}</td>
              <td>{{ $safeNavigationMigration(rsp.data.autrePaiement?.detailAutrePaiement?.dateDebutPeriode) | dateShortFr }} &#9656; {{ $safeNavigationMigration(rsp.data?.autrePaiement?.detailAutrePaiement?.dateFinPeriode) | dateShortFr }}</td>
              <td class="font-mono">{{ rsp.data.autrePaiement?.detailAutrePaiement?.numSecuOuvrantDroits }}</td>
              <td> {{ rsp.data.libVirement1 }} @if (rsp.data.libVirement2) {
                <span class="sub-line"><br/>{{ rsp.data.libVirement2 }}</span>
              }</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  @if (rsps.length === 0) {
    <div>
      <p>Aucun RSP "Opérations Ponctuelles"</p>
    </div>
  }
</div>